import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FileText, CheckCircle, ArrowRight } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";

const money = (c) => `$${Math.round((c || 0) / 100).toLocaleString()}`;

export default function ProposalReviewCard() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/quotes-review-queue").then(r => setRows(r.data.items)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const toOwner = async (q) => {
    const to_email = window.prompt("Owner email (blank = landlord linked to this property):", "");
    if (to_email === null) return;
    try {
      await api.post(`/quotes/${q.id}/review-ok`);
      const r = await api.post(`/jobs/${q.job_id}/request-owner-approval`, { estimate_cents: q.subtotal_cents, to_email, note: q.title });
      toast.success(`Approve/Reject email sent to ${r.data?.to_email || to_email || "owner"}`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail ?? "Could not send to owner")); }
  };
  const ok = async (q) => {
    try { await api.post(`/quotes/${q.id}/review-ok`); toast.success("Reviewed — finalize from the WO to send"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail ?? "Failed")); }
  };
  if (!rows || rows.length === 0) return null;
  return (
    <div className="border-2 border-amber-500 bg-white p-4 space-y-2" data-testid="proposal-review-card">
      <div className="flex items-center gap-2">
        <FileText weight="fill" size={20} className="text-amber-700"/>
        <div className="font-black uppercase tracking-widest text-xs text-slate-900">Proposals needing review</div>
        <span className="ml-auto text-[10px] font-black bg-amber-500 text-white px-2 py-0.5" data-testid="proposal-review-count">{rows.length}</span>
      </div>
      <div className="divide-y divide-slate-100">
        {rows.slice(0, 6).map(q => (
          <div key={q.id} className="py-2 flex items-center gap-2 text-xs" data-testid={`review-row-${q.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-slate-900 truncate">{q.title}</div>
              <div className="text-slate-500 truncate">WO# {q.wo_number} · {q.property_address}{q.unit ? ` #${q.unit}` : ""} · by {q.created_by}</div>
            </div>
            <div className="font-black text-slate-900">{money(q.subtotal_cents)}</div>
            <Link to={`/admin/jobs/${q.job_id}`} className="h-7 px-2 border border-slate-300 text-[9px] font-black uppercase tracking-widest inline-flex items-center gap-1 hover:bg-slate-50" data-testid={`review-open-${q.id}`}>Open <ArrowRight size={10}/></Link>
            <button onClick={() => toOwner(q)} className="h-7 px-2 bg-slate-900 hover:bg-slate-700 text-white text-[9px] font-black uppercase tracking-widest" data-testid={`review-owner-${q.id}`}>→ Owner</button>
            <button onClick={() => ok(q)} className="h-7 px-2 bg-emerald-600 hover:bg-emerald-700 text-white text-[9px] font-black uppercase tracking-widest inline-flex items-center gap-1" data-testid={`review-ok-${q.id}`}><CheckCircle weight="fill" size={10}/> OK</button>
          </div>
        ))}
      </div>
    </div>
  );
}
